export const LOAD_NOTIFICATIONS_REQUEST = 'LOAD_NOTIFICATIONS_REQUEST';
export const LOAD_NOTIFICATIONS_SUCCESS = 'LOAD_NOTIFICATIONS_SUCCESS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const RESET_UNREADED_COUNT = 'RESET_UNREADED_COUNT';